const pagesDevicesAddEn = {
  intro: {
    header: {
      headerTitle: "Add Device data to your Inventory",
    },
    body: {
      itemCard: {
        requiredDetails: "Required details:",
        deviceCategory: "Category",
        status: "Status",
        deviceName: "Device Name",
      },
      selectDeviceType: "Select the Type:",
      bulkAdd: "Bulk add by uploading a csv file",
      fillOutDetails: "Fill out the details",
    },
    options: {
      description: "Or you might want to...",
      syncIT: "Sync with external IT-Device services",
      bulkCsvUpload: {
        title: "Bulk add by uploading a csv file",
        description:
          "Use this option if you want to add multiple devices at once. Please prepare a csv file formatted according to DressCode's format.",
        button: "Add",
        selectedDeviceType: "Type:",
      },
    },
  },
  form: {
    navigation: {
      title: {
        profile: "Profile",
        software: "Software",
        hardware: "Hardware",
      },
      steps: {
        basic: {
          title: "Basic",
          deviceTypeLabel: "Device Type",
          deviceNameLabel: "Device Name",
          deviceNamePlaceholder: "Input Device Name",
          categoryLabel: "Category",
          manufacturerLabel: "Manufacturer",
          manufacturerPlaceholder: "Ex) Apple, Google, Microsoft...",
          serialNumberLabel: "Serial Number",
          serialNumberPlaceholder: "Input Serial Number",
          modelNumberLabel: "Model Number",
          modelNumberPlaceholder: "Input Model Number",
          assetTagLabel: "Asset Tag",
          assetTagPlaceholder: "Enter Asset Tag",
          deviceTagLabel: "Inventory ID",
          deviceTagPlaceholder: "Enter Inventory ID",
          productNameLabel: "Product Name / Model Name",
          productNamePlaceholder: "Enter Product Name / Model Name",
          remarksLabel: "Remarks",
          remarksPlaceholder: "Enter Remarks",
        },
        firmware: {
          title: "BIOS/Firmware",
          biosVendorLabel: "BIOS Vendor",
          biosVendorPlaceholder: "Enter BIOS Vendor",
          biosVersionLabel: "BIOS Version",
          biosVersionPlaceholder: "Enter BIOS Version",
          biosReleaseDateLabel: "BIOS Release Date",
          biosReleaseDatePlaceholder: "Select BIOS Release Date",
          firmwareTypeLabel: "Firmware Type",
          firmwareTypePlaceholder: "Enter Firmware Type",
          firmwareModeLabel: "Firmware Mode",
          firmwareModePlaceholder: "Enter Firmware Mode",
          biosUpdateEnabledLabel: "BIOS Update Enabled",
          secureBootEnabledLabel: "Secure Boot Enabled",
          biosPasswordSetLabel: "BIOS Password Set",
          tpmEnabledLabel: "TPM Enabled",
          tpmVersionLabel: "TPM Version",
          tpmVersionPlaceholder: "Enter TPM Version",
          intelTrustedExecutionTechnologyLabel:
            "Intel Trusted Execution Technology",
          biosLockWriteProtectionLabel: "BIOS Lock Write Protection",
          hardwareEncryptionSupportLabel: "Hardware Encryption Support",
          systemUuidLabel: "System UUID",
          systemUuidPlaceholder: "Enter System UUID",
          smbiosVersionLabel: "SMBIOS Version",
          smbiosVersionPlaceholder: "Enter SMBIOS Version",
          biosRomSizeBytesLabel: "BIOS ROM Size (Bytes)",
          biosRomSizeBytesPlaceholder: "Enter BIOS ROM Size in Bytes",
          bootSequenceOrderLabel: "Boot Sequence / Order",
          bootSequenceOrderPlaceholder: "Enter Boot Sequence or Order",
          wakeOnLanEnabledLabel: "Wake-on-LAN Status",
          pxeBootEnabledLabel: "PXE Boot Enabled",
          motherboardModelLabel: "Motherboard Model",
          motherboardModelPlaceholder: "Enter Motherboard Model",
          systemSerialNumberLabel: "System Serial Number",
          systemSerialNumberPlaceholder: "Enter System Serial Number",
          systemManufacturerLabel: "System Manufacturer",
          systemManufacturerPlaceholder: "Enter System Manufacturer",
          systemModelLabel: "System Model",
          systemModelPlaceholder: "Enter System Model",
          oemBiosCustomizationLabel: "OEM BIOS Customization",
          oemBiosCustomizationPlaceholder: "Enter OEM BIOS Customization",
        },
        gpu: {
          title: "GPU",
          gpuNameLabel: "GPU Name",
          gpuNamePlaceholder: "Enter GPU Name",
          gpuVendorLabel: "GPU Vendor",
          gpuVendorPlaceholder: "Enter GPU Vendor",
          gpuModelNumberLabel: "GPU Model Number",
          gpuModelNumberPlaceholder: "Enter GPU Model Number",
          gpuGenerationLabel: "GPU Generation",
          gpuGenerationPlaceholder: "Enter GPU Generation",
          gpuArchitectureLabel: "GPU Architecture",
          gpuArchitecturePlaceholder: "Enter GPU Architecture",
          gpuDedicatedMemoryBytesLabel: "Dedicated Memory (Bytes)",
          gpuDedicatedMemoryBytesPlaceholder: "Enter Dedicated Memory (Bytes)",
          gpuSharedMemoryBytesLabel: "Shared Memory (Bytes)",
          gpuSharedMemoryBytesPlaceholder: "Enter Shared Memory (Bytes)",
          gpuDriverVersionLabel: "Driver Version",
          gpuDriverVersionPlaceholder: "Enter Driver Version",
          gpuDriverProviderLabel: "Driver Provider",
          gpuDriverProviderPlaceholder: "Enter Driver Provider",
          gpuClockSpeedBaseHzLabel: "Clock Speed Base (Hz)",
          gpuClockSpeedBaseHzPlaceholder: "Enter Clock Speed Base (Hz)",
          gpuClockSpeedBoostHzLabel: "Clock Speed Boost (Hz)",
          gpuClockSpeedBoostHzPlaceholder: "Enter Clock Speed Boost (Hz)",
          gpuCudaCoresLabel: "CUDA Cores",
          gpuCudaCoresPlaceholder: "Enter CUDA Cores",
          gpuShaderUnitsLabel: "Shader Units",
          gpuShaderUnitsPlaceholder: "Enter Shader Units",
          gpuMaxDisplaySupportLabel: "Max Display Support",
          gpuMaxDisplaySupportPlaceholder: "Enter Max Display Support",
          gpuSupportedApisLabel: "Supported APIs",
          gpuSupportedApisPlaceholder: "Enter Supported APIs",
          gpuHardwareAccelerationLabel: "Hardware Acceleration Enabled",
        },
        processor: {
          title: "CPU",
          cpuNameLabel: "CPU Name",
          cpuNamePlaceholder: "Enter CPU Name",
          cpuVendorLabel: "CPU Vendor",
          cpuVendorPlaceholder: "Enter CPU Vendor",
          cpuSeriesLabel: "CPU Series",
          cpuSeriesPlaceholder: "Enter CPU Series",
          cpuGenerationLabel: "CPU Generation",
          cpuGenerationPlaceholder: "Enter CPU Generation",
          cpuCoreCountLabel: "CPU Core Count",
          cpuCoreCountPlaceholder: "Enter CPU Core Count",
          cpuThreadCountLabel: "CPU Thread Count",
          cpuThreadCountPlaceholder: "Enter CPU Thread Count",
          cpuClockSpeedHzLabel: "CPU Clock Speed (Hz)",
          cpuClockSpeedHzPlaceholder: "Enter CPU Clock Speed (Hz)",
          cpuMaxTurboFrequencyHzLabel: "CPU Max Turbo Frequency (Hz)",
          cpuMaxTurboFrequencyHzPlaceholder:
            "Enter CPU Max Turbo Frequency (Hz)",
          cpuCacheSizeL1BytesLabel: "CPU L1 Cache Size (Bytes)",
          cpuCacheSizeL1BytesPlaceholder: "Enter CPU L1 Cache Size (Bytes)",
          cpuCacheSizeL2BytesLabel: "CPU L2 Cache Size (Bytes)",
          cpuCacheSizeL2BytesPlaceholder: "Enter CPU L2 Cache Size (Bytes)",
          cpuCacheSizeL3BytesLabel: "CPU L3 Cache Size (Bytes)",
          cpuCacheSizeL3BytesPlaceholder: "Enter CPU L3 Cache Size (Bytes)",
          cpuTdpWattLabel: "CPU TDP (Watt)",
          cpuTdpWattPlaceholder: "Enter CPU TDP (Watt)",
          cpuSocketTypeLabel: "CPU Socket Type",
          cpuSocketTypePlaceholder: "Enter CPU Socket Type",
          cpuProcessNodeLabel: "CPU Process Node",
          cpuProcessNodePlaceholder: "Enter CPU Process Node",
        },
        ram: {
          title: "RAM",
          ramSizeBytesLabel: "RAM Size (Bytes)",
          ramSizeBytesPlaceholder: "Enter RAM Size (Bytes)",
          ramGenerationLabel: "Memory Type",
          ramGenerationPlaceholder: "Enter Memory Type",
          ramFormFactorLabel: "RAM Form Factor",
          ramFormFactorPlaceholder: "Enter RAM Form Factor",
          ramSpeedHzLabel: "RAM Speed (Hz)",
          ramSpeedHzPlaceholder: "Enter RAM Speed (Hz)",
          ramEccSupportedLabel: "ECC Supported",
          ramRegisteredLabel: "Registered RAM",
          ramManufacturerLabel: "RAM Manufacturer",
          ramManufacturerPlaceholder: "Enter RAM Manufacturer",
          ramSerialNumberLabel: "RAM Serial Number",
          ramSerialNumberPlaceholder: "Enter RAM Serial Number",
          ramManufactureDateLabel: "RAM Manufacture Date",
          ramManufactureDatePlaceholder: "Enter RAM Manufacture Date",
          ramPartNumberLabel: "RAM Part Number",
          ramPartNumberPlaceholder: "Enter RAM Part Number",
          ramJedecCompliantLabel: "JEDEC Compliant",
        },
        battery: {
          title: "Battery",
          batteryPresenceLabel: "Battery Present",
          batteryTypeLabel: "Battery Type",
          batteryTypePlaceholder: "Enter Battery Type",
          batteryManufacturerLabel: "Battery Manufacturer",
          batteryManufacturerPlaceholder: "Enter Battery Manufacturer",
          batteryModelNameLabel: "Battery Model Name",
          batteryModelNamePlaceholder: "Enter Battery Model Name",
          batterySerialNumberLabel: "Battery Serial Number",
          batterySerialNumberPlaceholder: "Enter Battery Serial Number",
          batteryManufactureDateLabel: "Battery Manufacture Date",
          batteryManufactureDatePlaceholder: "Enter Battery Manufacture Date",
          batteryDesignCapacityMWhLabel: "Battery Design Capacity (mWh)",
          batteryDesignCapacityMWhPlaceholder:
            "Enter Battery Design Capacity (mWh)",
        },
        monitor: {
          title: "Monitor",
          sizeInInchLabel: "Size (Inch)",
          sizeInInchPlaceholder: "Enter Size (Inch)",
          resolutionWidthLabel: "Resolution Width",
          resolutionWidthPlaceholder: "Enter Resolution Width",
          resolutionHeightLabel: "Resolution Height",
          resolutionHeightPlaceholder: "Enter Resolution Height",
          numberOfColorsLabel: "Number of Colors",
          numberOfColorsPlaceholder: "Enter Number of Colors",
          refreshRateHzLabel: "Refresh Rate (Hz)",
          refreshRateHzPlaceholder: "Enter Refresh Rate (Hz)",
          displayTypeLabel: "Display Type",
          displayTypePlaceholder: "Enter Display Type",
          manufactureDateLabel: "Manufacture Date",
          manufactureDatePlaceholder: "Enter Manufacture Date",
          panelTypeLabel: "Panel Type",
          panelTypePlaceholder: "Enter Panel Type",
          aspectRatioLabel: "Aspect Ratio",
          aspectRatioPlaceholder: "Enter Aspect Ratio",
          brightnessLabel: "Brightness",
          brightnessPlaceholder: "Enter Brightness",
          contrastRatioLabel: "Contrast Ratio",
          contrastRatioPlaceholder: "Enter Contrast Ratio",
          colorGamutLabel: "Color Gamut",
          colorGamutPlaceholder: "Enter Color Gamut",
          inputPortsLabel: "Input Ports",
          inputPortsPlaceholder: "Enter Input Ports",
          activePortUsedLabel: "Active Port Used",
          activePortUsedPlaceholder: "Enter Active Port Used",
          touchCapabilityLabel: "Touch Capability",
          touchCapabilityPlaceholder: "Enter Touch Capability",
          displayArrangementLabel: "Display Arrangement",
          displayArrangementPlaceholder: "Enter Display Arrangement",
          rotationPivotModeLabel: "Rotation/Pivot Mode",
          rotationPivotModePlaceholder: "Enter Rotation/Pivot Mode",
        },
        os: {
          title: "Operating System",
          operatingSystemTypeLabel: "Operating System Type",
          operatingSystemTypePlaceholder: "Enter Operating System Type",
          osVersionLabel: "OS Version",
          osVersionPlaceholder: "Enter OS Version",
          osNameLabel: "OS Name",
          osNamePlaceholder: "Enter OS Name",
          osEditionLabel: "OS Edition",
          osEditionPlaceholder: "Enter OS Edition",
          buildNumberLabel: "Build Number",
          buildNumberPlaceholder: "Enter Build Number",
          servicePackPatchLevelLabel: "Service Pack/Patch Level",
          servicePackPatchLevelPlaceholder: "Enter Service Pack/Patch Level",
          securityPatchDateLabel: "Security Patch Date",
          securityPatchDatePlaceholder: "Enter Security Patch Date",
          automaticUpdatesEnabledLabel: "Automatic Updates Enabled",
          kernelVersionLabel: "Kernel Version",
          kernelVersionPlaceholder: "Enter Kernel Version",
          architectureLabel: "Architecture",
          architecturePlaceholder: "Enter Architecture",
          bitnessLabel: "Bitness",
          bitnessPlaceholder: "Enter Bitness",
          withVirtualOsLabel: "With Virtual OS",
          osSupportLifecycleLabel: "OS Support Lifecycle",
          osSupportLifecyclePlaceholder: "Enter OS Support Lifecycle",
          firewallStatusLabel: "Firewall Status",
          firewallStatusPlaceholder: "Enter Firewall Status",
          antivirusSoftwareCompatibilityLabel:
            "Antivirus Software Compatibility",
          antivirusSoftwareCompatibilityPlaceholder:
            "Enter Antivirus Software Compatibility",
        },
        osSetting: {
          title: "OS Setting",
          osInstallDateLabel: "OS Install Date",
          osInstallDatePlaceholder: "Enter OS Install Date",
          bootModeLabel: "Boot Mode",
          bootModePlaceholder: "Enter Boot Mode",
          diskEncryptionEnabledLabel: "Disk Encryption Enabled",
        },
        storage: {
          title: "Storage",
          typeLabel: "Storage Type",
          typePlaceholder: "Select storage type",
          nameLabel: "Product Name / Model",
          namePlaceholder: "Enter product name or model name",
          capacityMBLabel: "Capacity (MB)",
          capacityMBPlaceholder: "Enter capacity in MB",
          storageInterfaceTypeLabel: "Interface Type",
          storageInterfaceTypePlaceholder: "Enter interface type",
          storageFormFactorLabel: "Form Factor",
          storageFormFactorPlaceholder: "Enter form factor",
          storageSlotNumberLabel: "Slot Number",
          storageSlotNumberPlaceholder: "Enter slot number",
          storageManufacturerLabel: "Manufacturer",
          storageManufacturerPlaceholder: "Enter manufacturer",
          storageSerialNumberLabel: "Serial Number",
          storageSerialNumberPlaceholder: "Enter serial number",
          storageFirmwareVersionLabel: "Firmware Version",
          storageFirmwareVersionPlaceholder: "Enter firmware version",
          storageCacheSizeBytesLabel: "Cache Size (Bytes)",
          storageCacheSizeBytesPlaceholder: "Enter cache size in bytes",
          storageNandTypeLabel: "NAND Type",
          storageNandTypePlaceholder: "Enter NAND type",
          storageTrimSupportLabel: "TRIM Support",
          storageTrimSupportPlaceholder: "Is TRIM supported?",
        },
        license: {
          title: "License",
          licenseIdLabel: "License ID",
          licenseIdPlaceholder: "Enter License ID",
        },
        responsibilityOwner: {
          title: "Responsibility Owner",
          personIdLabel: "Person ID",
          personIdPlaceholder: "Enter Person ID",
          responsibilityOwnerValidFrom: "Responsibility Start Date",
          notAssigned: "Not Assigned",
        },
        responsibilityOrg: {
          title: "Organization",
        },
        placement: {
          title: "Placement",
          placeIdLabel: "Place",
          placeIdPlaceholder: "Enter Place",
          placementValidFromLabel: "Placement Date",
          placementValidFromPlaceholder: "Enter Placement Date",
          buildingNameLabel: "Building Name",
          buildingNamePlaceholder: "Enter Building Name",
          floorNumberLabel: "Floor Number",
          floorNumberPlaceholder: "Enter Floor Number",
          areaZoneNameLabel: "Area / Zone Name",
          areaZoneNamePlaceholder: "Enter Area / Zone Name",
          deskSeatNumberLabel: "Desk/Seat Number",
          deskSeatNumberPlaceholder: "Enter Desk/Seat Number",
          reasonForPlacementLabel: "Reason for Placement",
          reasonForPlacementPlaceholder: "Enter Reason for Placement",
        },
        placementDetail: {
          title: "Placement Detail",
          rackNumberLabel: "Rack Number",
          rackNumberPlaceholder: "Enter Rack Number",
          rackUPositionLabel: "Rack U Position",
          rackUPositionPlaceholder: "Enter Rack U Position",
          shelfCabinetNumberLabel: "Shelf/Cabinet Number",
          shelfCabinetNumberPlaceholder: "Enter Shelf/Cabinet Number",
          placementWidthCentimeterLabel: "Placement Width (cm)",
          placementWidthCentimeterPlaceholder: "Enter Placement Width (cm)",
          placementHeightCentimeterLabel: "Placement Height (cm)",
          placementHeightCentimeterPlaceholder: "Enter Placement Height (cm)",
          placementDepthCentimeterLabel: "Placement Depth (cm)",
          placementDepthCentimeterPlaceholder: "Enter Placement Depth (cm)",
          placementConditionLabel: "Placement Condition",
          placementConditionPlaceholder: "Enter Placement Condition",
        },
        assetManagement: {
          title: "Asset Management",
          tagLabel: "Tag",
          fixedAssetLabel: "Fixed Asset",
          fixedAssetSelection: "This device is a fixed asset.",
          notFixedAssetSelection: "This device is NOT a fixed asset.",
          assetTagLabel: "Asset Number",
          assetTagDescription: "A number for tracking assets.",
          assetTagPlaceholder: "Input number",
          assetRadioGroup: {
            equipment: "Do not register as Fixed Asset",
            fixedAsset: "Register as Fixed Asset",
            lease: "Register as Lease",
          },
          deviceTagLabel: "Device Tag",
          deviceTagDescription:
            "A tag specifically for tracking devices, used when an additional tag is required beyond the asset number.",
          deviceTagPlaceholder: "Input tag",
          memoLabel: "Memo",
          memoPlaceholder: "Takes notes on this device",
          labelType: "Label Type",
          managementLabel: "Management Label",
          generateLabels: "Generate Labels",
        },
        generatePdf: {
          deviceManagementLabel: "Device management label",
          pdfGenerationRequestFailed: "Failed to send PDF generation request",
          popupBlocked:
            "Popup was blocked. Please check your browser settings.",
          taskCompletionFailed: "Task completion process failed",
          preparingPdfGeneration: "Preparing PDF generation...",
          generatingPdf: "Generating PDF...",
          checkGenerationStatus:
            "Click the 'Reload' button to check generation status",
          clickCompleteAfterPrint:
            "Click the 'Mark as completed' button after printing is finished",
          // Additional keys needed by the component
          generatePdf: "Generate PDF",
          markAsCompleted: "Mark as completed",
          reload: "Reload",
          print: "Print",
          retry: "Retry",
          pdfReady: "PDF generation completed",
          printDialogOpened: "Print dialog opened",
          printCompleted: "Print task completed",
          successToCompleteTask: "Task completed successfully",
          failedToCompleteTask: "Failed to complete task",
          waitForLabelGeneration:
            "Please wait for label generation task to complete",
          printAgain: "Print again",
        },
        assignment: {
          title: "Assignment & Allocation",
          assignmentLabel: "Assignment",
          assignmentRadioGroup: {
            assignment: "Assign",
            notAssignment: "No assignment (in stock)",
          },
          assigneeLabel: "Assignee",
          assignmentDateLabel: "Assignment Date",
          allocationLabel: "Allocation",
          allocationRadioGroup: {
            allocation: "Allocate",
            notAllocation: "No allocation (in stock)",
          },
          placeLabel: "Place",
          allocationDateLabel: "Allocation Date",
          allocatePlaceholder: "Select Place...",
          notAssigned: "Not Assigned",
        },
        software: {
          title: "Software",
          osLabel: "OS",
          osPlaceholder: "Select OS...",
          versionLabel: "Version",
          versionPlaceholder: "Ex) 11, Ventura...",
          buildLabel: "Build",
          buildPlaceholder: "(Windows)22H2, (macOS)12.1.2...",
          otherOSLabel: "Other",
        },
        hardware: {
          title: "Hardware",
          processorInfoLabel: "Processor Info",
          manufacturerLabel: "CPU Manufacturer",
          manufacturerPlaceholder: "Ex) Intel, AMD, Apple...",
          chipLabel: "Chip",
          chipPlaceholder: "Ex) Core i7-9900K , Ryzen 7 5800H...",
          cpuArchitectureLabel: "CPU Architecture",
          cpuArchitecturePlaceholder: "Ex) arm, x86_64...",
          coreLabel: "core",
          cpuSpecLabel: "CPU Spec",
          processorLabel: "CPU Processor",
          cpuCoreLabel: "CPU Core",
          cpuClockLabel: "CPU Clock",
          memoryLabel: "Memory",
          capacityLabel: "Capacity",
          storageTypeLabel: "Storage Type",
          storageSizeLabel: "Storage Size",
          displayLabel: "Display",
          sizeLabel: "Size",
          widthLabel: "Width",
          heightLabel: "Height",
          resolutionLabel: "Resolution",
          refreshRateLabel: "Refresh Rate",
          portLabel: "External Port",
          portTypeLabel: "Port Type",
          portSpecificationLabel: "Port Specification",
          portSpecificationPlaceholder: "Ex) 2.0, 3.2...",
          portCountLabel: "Port Number",
          typeNumberPlaceholder: "Type number",
          networkInterfaceLabel: "Network Interface",
          networkInterfaceTypeLabel: "Interface Type",
          networkInterfaceMacAddressLabel: "MAC Address",
          addAnother: "Add Another",
          selectTypePlaceholder: "Select Type...",
        },
      },
      completed: {
        result: "Result",
        message: "Device added.",
        goToDevice: "Go to Device",
        completedBy: "Completed by:",
      },
      common: {
        device: "Device",
        serialNumber: "Serial Number",
        assetNumber: "Asset Number",
        dateInService: "Date In Service",
        acquisitionDate: "Acquisition Date",
        assignedTo: "Assigned To",
        assignedAt: "Assigned At",
        unassiged: "Unassigned",
        submitButtonLabel: "Add device",
        errorDuplicateSerialNumber:
          "The combination of manufacturer and serial number is already registered.",
        errorDuplicateDeviceTag:
          "Asset Tag / Inventory ID is already registered.",
        errorDuplicate:
          "Serial number, Asset number, or Device tag is already registered.",
      },
    },
    progressbar: {
      total: "Total",
      mustItem: "Must Item",
      left: "{{value}}left",
      filled: "filled",
      modeSetting: "Mode Settings",
      mustItemOnly: "Must item only",
    },
  },
};

export default pagesDevicesAddEn;
